import ArticleFilter from './components/article/ArticleFilter';
import ArticleComments from './components/article/ArticleComments';
import RectificationForm from './components/article/RectificationForm';
import ArchiveFilter from './components/archive/ArchiveFilter';
import SearchFilter from './components/search/SearchFilter';
import SearchBar from './components/search/SearchBar';
import ArticleBlock from './components/blocks/ArticleBlock';
import MediaButtons from './components/blocks/MediaButtons';
import BackToTop from './components/navigation/BackToTop';
import Toc from './components/navigation/Toc';
import Header from './components/Header';
import Footer from './components/Footer';
import Anchor from './components/Anchor';
import Preloader from './components/Preloader';
import CookieWall from './components/blocks/CookieWall';

export default [
  {
    selector: '.js-article-filter',
    component: ArticleFilter
  },
  {
    selector: '.js-rectification-form',
    component: RectificationForm
  },
  {
    selector: '.js-archive-filter',
    component: ArchiveFilter
  },
  {
    selector: '.js-search-filter',
    component: SearchFilter
  },
  {
    selector: '.js-article-block',
    component: ArticleBlock
  },
  {
    selector: '.js-backToTop-button',
    component: BackToTop
  },
  {
    selector: '.js-toc',
    component: Toc
  },
  {
    selector: '.js-article-comments-form',
    component: ArticleComments
  },
  {
    selector: '.js-header',
    component: Header
  },
  {
    selector: '.js-footer',
    component: Footer
  },
  {
    selector: '.js-searchBar',
    component: SearchBar
  },
  {
    selector: '.js-media-buttons',
    component: MediaButtons
  },
  {
    selector: 'a',
    component: Anchor
  },
  {
    selector: '.js-preloader',
    component: Preloader
  },
  {
    selector: '.js-cookie-wall',
    component: CookieWall
  }
];



// WEBPACK FOOTER //
// frontend/js/settings.js